// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1uvXv","paramInput":"JobSimulator_paramInput__2BvJK","input":"JobSimulator_input__-uIvc"};